import { render, staticRenderFns } from "./affirmList.vue?vue&type=template&id=0c148a19"
import script from "./affirmList.vue?vue&type=script&lang=js"
export * from "./affirmList.vue?vue&type=script&lang=js"
import style0 from "./affirmList.vue?vue&type=style&index=0&id=0c148a19&prod&lang=stylus"
import style1 from "./affirmList.vue?vue&type=style&index=1&id=0c148a19&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports